import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useDeleteExperience() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (experienceId: number) =>
      apiMutation('DELETE', {
        path: ENDPOINTS.deleteExperience,
        params: { id: experienceId.toString() },
      }) as Promise<void>,
    onSuccess: (_, experienceId) => {
      message.success(`Activity #${experienceId} successfully deleted`);

      queryClient.removeQueries({
        queryKey: [CORE_QUERY_KEYS.experience, { id: experienceId.toString() }],
      });

      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.experiences],
      });
    },
    onError: () => {
      message.error('Failed to delete activity. Activity may be in use.');
    },
  });
}
